<div class="row">
  <div class="col-6">
    <h1>
      <span *ngIf="!editData">Cotización</span
      ><small *ngIf="editData">Editando contrato #{{ editData.id }}</small>
    </h1>
  </div>
</div>

<form [formGroup]="quotationForm" class="form-horizontal">
  <div class="row">
    <div class="col-md-8 mb-4">
      <div class="card full-height">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <label class="form-labels">% APR</label>
              <select
                formControlName="apr"
                class="form-select"
                (change)="updateData()"
              >
                <option selected></option>
                <option *ngFor="let apr of aprs">{{ apr }}</option>
              </select>
            </div>

            <div class="col-md-6">
              <label class="form-labels">Prima Total</label>
              <div class="input-group flex-nowrap">
                <img
                  class="input-group-text"
                  width="40"
                  src="./assets/icons/dollar.svg"
                />
                <input
                  type="number"
                  formControlName="premium"
                  class="form-control"
                  (change)="updateData()"
                />
              </div>
            </div>
            <div class="col-md-6">
              <label
                class="form-labels mt-4"
                [style]="prontoAlert ? 'color:red;' : ''"
                >Pronto</label
              >
              <!--default 25%-->

              <div class="input-group flex-nowrap">
                <img
                  class="input-group-text"
                  width="40"
                  src="./assets/icons/dollar.svg"
                  [style]="prontoAlert ? 'border-color: red; color:red;' : ''"
                />
                <input
                  type="number"
                  class="form-control"
                  formControlName="downPayment"
                  (change)="checkProntoMin()"
                  [style]="prontoAlert ? 'border-color: red; color:red;' : ''"
                />
            </div>
            <span *ngIf="downPaymentMsg" style="color: red;">{{downPaymentMsg}}</span>
            </div>

            <!-- Start Multi Policy - Move to Contract -->

            <!-- <div class="col-md-6">
                            <label class="form-labels mt-4">¿Este contrato tendra multiples polizas?</label><br/>
                            <div class="form-check form-check-inline mt-1">
                                <input class="form-check-input" type="radio" value="si" name="select" (change)="checkMultiPolicy($event)" [(ngModel)]="myRadio" [ngModelOptions]="{standalone: true}">
                                <label class="form-check-label">Si</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input"  name="select" type="radio" value="no" (change)="checkMultiPolicy($event)" [(ngModel)]="myRadio" [ngModelOptions]="{standalone: true}">
                                <label class="form-check-label">No</label>
                            </div>
                        </div>
                        <div class="col-md-6" *ngIf="showMultiPolicies">
                            <label class="form-labels mt-4">Agencia / Sucursal</label>
                            <select [(ngModel)]="selectedCompany" [ngModelOptions]="{standalone: true}" class="form-select">
                                <option selected></option>
                                <option [ngValue]="company" *ngFor="let company of companies">{{ company.name }}
                                </option>
                            </select>
                        </div>

                    <div class="col-md-12" *ngIf="showMultiPolicies">
                        <app-multi-policies [editPoliciesJson]="policiesJson" [balance]="primaValue" [companyId]="selectedCompany?.id" (formReady)="addChildForm('policiesJson', $event)"></app-multi-policies>
                    </div> -->

            <!-- END Multi Policy -->

            <!-- <div class="col-md-6">
                        <label class="form-labels mt-4">¿Desea hacer pagos trimestrales?</label><br/>
                        <div class="form-check form-check-inline mt-1">
                            <input class="form-check-input" type="radio" value="si" name="select2" [(ngModel)]="isTrimester" [ngModelOptions]="{standalone: true}" (change)="changeToTrimester($event)" >
                            <label class="form-check-label">Si</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input"  name="select2" type="radio" value="no" [(ngModel)]="isTrimester" [ngModelOptions]="{standalone: true}" (change)="changeToTrimester($event)">
                            <label class="form-check-label">No</label>
                        </div>
                    </div> -->

            <!-- <div class="form-check" *ngIf="showTrimesterPayments">
                        <input formControlName="quarterlyPayments" [(ngModel)]="trimesterPayIsChecked" class="form-check-input" type="checkbox" value="true" id="quarterlyPayments" (change)="changeToTrimester($event)">
                        <label class="form-check-label" for="quarterlyPayments">
                          Hacer pagos trimestrales
                        </label>
                    </div> -->
                    
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 mb-4">
      <div class="card full-height">
        <div class="card-body">
          <!-- <h5 class="card-title">Card title</h5>
            <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
            <a href="#" class="btn btn-primary">Go somewhere</a> -->
          <div class="row quote-res">
            <div class="col-12">
              <label class="form-labels">A financiar</label>
              <div class="input-group flex-nowrap">
                <img
                  class="input-group-text"
                  width="40"
                  src="./assets/icons/dollar.svg"
                />
                $
                <input
                  type="number"
                  formControlName="financingAmmount"
                  value=""
                  class="form-control"
                />
              </div>
            </div>
            <!-- <div class="col-12" *ngIf="showCompulsoryIns">
                    <label class="form-labels mt-2">S / Obligatorio</label>
                    <div class="input-group flex-nowrap">
                        $<input type="number" formControlName="compulsoryIns" [disabled]="true" class="form-control">
                    </div>
                </div> -->
            <div class="col-12">
              <label class="form-labels mt-2">Porciento de Interés</label>
              <div class="input-group flex-nowrap">
                <input
                  type="number"
                  formControlName="aprSelection"
                  value=""
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-12">
              <label class="form-labels mt-2">Interes a pagar</label>
              <div class="input-group flex-nowrap">
                <img
                  class="input-group-text"
                  width="40"
                  src="./assets/icons/dollar.svg"
                />
                $<input
                  type="number"
                  formControlName="interestPay"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-12">
              <label class="form-labels mt-2">Total a Pagar</label>
              <div class="input-group flex-nowrap">
                <img
                  class="input-group-text"
                  width="40"
                  src="./assets/icons/dollar.svg"
                />
                $<input
                  type="number"
                  formControlName="totalPayment"
                  value=""
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-12">
              <label class="form-labels mt-2">Pago Mensual</label>
              <div class="input-group flex-nowrap">
                <img
                  class="input-group-text"
                  width="40"
                  src="./assets/icons/dollar.svg"
                />
                $<input
                  type="number"
                  formControlName="splitPayments"
                  value=""
                  class="form-control"
                />
              </div>
            </div>
            <!-- <div class="col-12">
                    <label class="form-labels mt-2">Porciento de Interés Anual</label>
                    <input type="number" formControlName="annualPercent" 
                        value="" class="form-control">
                </div> -->
            <!-- <div class="col-12">
                    <label class="form-labels mt-2">Fecha de Primer Pago</label>
                    <div class="input-group flex-nowrap">
                        <img class="input-group-text" width="40" src="./assets/icons/dollar.svg" />
                        <input type="number" formControlName="annualPercent" [disabled]="true" placeholder="" class="form-control">
                    </div>
                </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">Plazo</th>
                  <th scope="col">Pago mensual</th>
                  <th scope="col">Interes a pagar</th>
                  <th scope="col">Total a pagar</th>
                  <!-- <th scope="col">A financiar</th> -->
                  <th scope="col">% de interes</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let plazo of filterPlazos">
                  <td>
                    <input
                      type="radio"
                      formControlName="months"
                      value="{{ plazo.months }}"
                      (change)="updateData()"
                      aria-label="Radio button for selection Plazo"
                    />
                  </td>
                  <td>
                    <strong>{{ plazo.months }}</strong>
                  </td>
                  <td>{{ plazo.monthlyPay | currency }}</td>
                  <td>{{ plazo.interestPay | currency }}</td>
                  <td>{{ plazo.totalPayment | currency }}</td>
                  <td>{{ plazo.apr }}%</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <div class="form-check" *ngIf="showTrimesterPayments">
                    <input formControlName="quarterlyPayments" [(ngModel)]="trimesterPayIsChecked" class="form-check-input" type="checkbox" value="true" id="quarterlyPayments" (change)="changeToTrimester($event)">
                    <label class="form-check-label" for="quarterlyPayments">
                      Hacer pagos trimestrales
                    </label>
                </div> -->
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12" style="text-align: right">
      <button
        [disabled]="wrongPronto || quotationForm.invalid"
        type="button"
        class="btn btn-primary mt-4"
        (click)="createContract()"
      >
        Continuar
      </button>
      <div *ngIf="msg" style="color: rgb(255, 62, 62)">{{ msg }}</div>
    </div>
  </div>
</form>
